import {Component, EventEmitter, Input, Output} from '@angular/core';

/**
 * Generated class for the SearchBarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'search-bar',
  templateUrl: 'search-bar.html'
})
export class SearchBarComponent {

  @Input() public value: string;
  @Input() public placeholder: string;
  @Output() public text: EventEmitter<any> = new EventEmitter();


  constructor() {}

  emit(event){
    this.text.emit(event.target.value)
  }
}



// WEBPACK FOOTER //
// ./src/components/search-bar/search-bar.ts